export default __webpack_public_path__ + "files/64.15bc7ba6593001a4ef937d7fdef1a3df.png";